import { Component, OnInit } from '@angular/core';
import { PanjaInfoServiceService } from '../../../services/raintree/Transmission/panja-info-service.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PanjaBottomSheetComponent } from './panja-bottom-sheet/panja-bottom-sheet.component';
import { RefreshedDateKey } from '../../../enum/refresh-date';

@Component({
  selector: 'app-panja-details',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule,],
  templateUrl: './panja-details.component.html',
  styleUrl: './panja-details.component.scss',
  providers: [DatePipe]
})
export class PanjaDetailsComponent implements OnInit {
  showSlot: boolean=false;
  value: string = '';
  lastRefreshedDate: any = [];
  constructor(
    private panjaService: PanjaInfoServiceService,
    private bottomSheet: MatBottomSheet,
    private date: DatePipe
  ) { }
  // data = [
  //   {
  //     panjaType: "Saha Prati Ritwik",
  //     panjaIssued: "13 November, 2000",
  //     panjaLastRenewal: "31 December, 2023",
  //     panjaNextRenewal: "July conference, 2026",
  //   }
  // ]
  slot: any={}
  panjaData: any = [];
  panjaRenewalData: any[] = []
  renewDue = new FormControl(true)
  isVisible: boolean = false
  failedArr: any = [92, 94, 96, 100, 101, 102]
  demoArr = [
    { due: [90] },
    { istsArr: [91, 92] },
    { ustavArr: [93, 94] },
    { dikshaArr: [95, 96] },
    { panjaSubmitted: [97] },
    { panjaReceived: [98] },
    { renewalArr: [99, 100, 101, 102] },
    // { renewalReject: [99, 101] },
    // { ab: [99, 102] },
    
  ]

  typeArr: any = {
    JK: [91, 93] ,
    ADJ: [91, 93],
    SPR: [91, 93, 95]
  }

  // passedArr: any = [90, 91, 93, 95, 97, 98, 99]
  isMobile: boolean = false
  filterAscOrder: any = []
  filteredData: any = []
  allLatestRemark: any = []
  renewalRemark: any = []

  ngOnInit(): void {
    this.isMobile = window.matchMedia('(max-width: 500px)').matches
    this.getPanjaDetails()
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
        if (refreshDate) {
          this.lastRefreshedDate = refreshDate.filter((item: any) => item.configName.includes(RefreshedDateKey.panjaRenawalSlot))
          this.lastRefreshedDate = JSON.parse(this.lastRefreshedDate[0].date),
          console.log(this.lastRefreshedDate);
          
        }
  }

  getPanjaDetails() {
    this.panjaService.getPanjaInfo().subscribe({
      next: (res) => {
        this.panjaData = res.data
        this.value = this.panjaData[0].panjaRenewDewOn
        console.log(this.value);
        
        this.isVisible = this.panjaData[0].pendingPanjaRenewal
        if (this.isVisible && !this.isMobile) {
          this.getPanjaRenewalInfo()
        } else {
          this.getPanjaRenewalInfo()
        }

      }
    })
  }

  get formattedDate(): Date {
  const year = Number(this.value.substring(0, 4));
  const month = Number(this.value.substring(4, 6)) - 1; 
  return new Date(year, month);
}



  getPanjaRenewalInfo() {
    this.panjaService.getPanjaRenewalInfo().subscribe({
      next: (res) => {
        this.panjaRenewalData = res.data
        this.panjaRenewalData.forEach(item => {
          item.isfailed = this.failedArr.includes(item.statusCode)
          if (item.renewalProcess.length > 1) {
            item.latestRemark = item.renewalProcess.reduce((acc: any, curr: any) => {
              return new Date(curr.remarkAddedOn).getTime() > new Date(acc.remarkAddedOn).getTime() ? curr : acc
            })
            item.renewalProcess.sort((a: any, b: any) => {
              return new Date(b.remarkAddedOn).getTime() - new Date(a.remarkAddedOn).getTime()
            })

          }
        })
        this.filterAscOrder = [...this.panjaRenewalData]
        this.filterAscOrder.sort((a: any, b: any) => {
          const fastA = a.renewalProcess[0]?.remarkAddedOn
          const fastB = b.renewalProcess[0]?.remarkAddedOn
          
          return new Date(fastA).getTime() - new Date(fastB).getTime()
        })
        const has97=this.filterAscOrder.some((item:any)=>item.statusCode==97);
        const has98=this.filterAscOrder.some((item:any)=>item.statusCode==98);
        let showHold=false;
        this.slot=this.filterAscOrder.find((item:any)=>item.statusCode==97)?.panjaRecieveTimeSlot;

        // this.slot = this.slot.replace('SLOT-1', this.lastRefreshedDate)

        this.lastRefreshedDate.find((item: any) => {
  if (this.slot.includes(item.slot)) {
    this.slot = this.slot.replace(item.slot, item.time);
     }
      });
        
        let recordCheckPassed=false;
        if(has97){
         showHold=this.filterAscOrder.at(-1).statusCode==100;
        }
        if(!showHold){
          this.filterAscOrder=this.filterAscOrder.filter((item:any)=>![100].includes(item.statusCode));
        }
        recordCheckPassed=this.typeArr[this.panjaData[0].workerType].every((code:any) =>
            this.filterAscOrder.some((item:any) => item.statusCode === code)
        );
        if(recordCheckPassed && (has97 || has98) && !showHold){
          this.showSlot=true;
        }
        const status_code = this.filterAscOrder.map((item: any) => item.statusCode)

        this.demoArr.forEach(item => {
          const [[keys, values]] = Object.entries(item)


          const matchValue = values.find((v: any) => status_code.includes(v))

          const filter = this.filterAscOrder.filter((item: any) => {
            return item.statusCode === matchValue
          })
          this.filteredData.push(...filter)

        })
       
        

      }
    })
  }

  check() {
    this.bottomSheet.open(PanjaBottomSheetComponent, {
      data: { data :this.filteredData,
        slot: this.slot,
        showSlot:this.showSlot
      },
      panelClass: 'custom-bottom-sheet'
    })
  }
}
